import type { VerifyMemoryResult } from '../../api/memory-v2'

export function ProvenanceChain({ verify }: { verify: VerifyMemoryResult }) {
  return (
    <div className="space-y-2 rounded-lg border border-harbor-border bg-harbor-surface p-3">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-harbor-text">Provenance</span>
        <span className="rounded-full bg-harbor-surface-raised px-2 py-0.5 text-xs text-harbor-text-secondary">
          {verify.verificationState}
        </span>
      </div>
      <div>
        <h4 className="text-xs font-semibold uppercase tracking-wide text-harbor-text-secondary">
          Source chain
        </h4>
        {verify.sourceChain.length === 0 ? (
          <p className="text-sm text-harbor-text-muted">No linked sources — treat as unverified.</p>
        ) : (
          <ul className="mt-1 list-inside list-disc text-sm text-harbor-text">
            {verify.sourceChain.map((entry) => (
              <li key={entry}>{entry}</li>
            ))}
          </ul>
        )}
      </div>
      {verify.conflictIds.length > 0 && (
        <div>
          <h4 className="text-xs font-semibold uppercase tracking-wide text-harbor-text-secondary">
            Conflicts (unresolved)
          </h4>
          <ul className="mt-1 list-inside list-disc text-sm text-harbor-text">
            {verify.conflictIds.map((entry) => (
              <li key={entry}>{entry}</li>
            ))}
          </ul>
        </div>
      )}
      {verify.supersessionChain.length > 0 && (
        <p className="text-xs text-harbor-text-muted">
          Superseded by: {verify.supersessionChain.join(' → ')}
        </p>
      )}
      <p className="text-sm text-harbor-text-secondary">{verify.explanation}</p>
    </div>
  )
}
